export default __webpack_public_path__ + "static/media/content.4484e4cf.jpg";